import { NavLink } from 'react-router-dom'

import ohip from '../../img/pms/ohip.png'
import styles from './PmsMessage.module.scss'

const logos = {
  ohip
}

const SwitchToOhip = ({ pmsLoginLink }) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.logo}>
        <img src={logos['ohip']} alt={`${ohip} logo`} />
      </div>
      <p className={styles.text}>Switch to OHIP for more reliable PMS sync.</p>
      <NavLink to={pmsLoginLink}>
        <button className={styles.primaryButton}>Switch</button>
      </NavLink>
    </div>
  )
}

export default SwitchToOhip
